import { Box } from "@bca/ui-library";
import React, { useEffect, useState } from "react";
import {
  PurchasesUrlQueryParams,
  SORT_OPTIONS,
} from "../APICalls/buildGetPurchasesUrl";

import Header from "./MobileFilters/Header";
import Content from "./MobileFilters/Content";
import Footer from "./MobileFilters/Footer";
import Filter from "../Interfaces/Filter";
import { AppliedCheckboxResult } from "../Hooks/useAppliedCheckBoxes";
import SortOption from "../Interfaces/SortOption";
import { DEFAULT_PURCHASES_PARAMETERS } from "../../pages";

interface DateRangeMobileContainerProps {
  filters: Filter[];
  sortOptions: SortOption[];
  prevQ?: String;
  hideDateRangeMobile: () => void;
  purchasesUrlParams: PurchasesUrlQueryParams;
  setPurchasesUrlParams: (purchasesUrlParams: PurchasesUrlQueryParams) => void;
  onClearAll: () => void;
  isToUseAuthZero?: boolean;
}

const DateRangeMobileContainer: React.FunctionComponent<
  DateRangeMobileContainerProps & AppliedCheckboxResult
> = ({
  filters,
  sortOptions,
  prevQ = "",
  hideDateRangeMobile,
  appliedCheckboxes,
  setAppliedCheckboxesCheckBoxGroup,
  setAppliedCheckboxesCheckBoxGroupRemoveChip,
  purchasesUrlParams,
  setPurchasesUrlParams,
  onClearAll,
  setAppliedCheckboxesSingleSelect,
  isToUseAuthZero
}) => {
  const [modalPurchasesUrlParams, setModalPurchasesUrlParams] =
    useState(purchasesUrlParams);

  const [isScrolledToTop, setIsScrolledToTop] = useState<boolean>(true);
  const [shouldShowVrmQueryWarning, setShouldShowVrmQueryWarning] =
    useState<boolean>(false);
  const [totalResults, setTotalResults] = useState(0);

  const isMobileClearAllDisabled =
    modalPurchasesUrlParams.numberofDays ===
      DEFAULT_PURCHASES_PARAMETERS.numberofDays &&
    modalPurchasesUrlParams.q === DEFAULT_PURCHASES_PARAMETERS.q &&
    modalPurchasesUrlParams.sort === DEFAULT_PURCHASES_PARAMETERS.sort &&
    modalPurchasesUrlParams.additionalFilters.bq ===
      DEFAULT_PURCHASES_PARAMETERS.additionalFilters.bq;

  const onMobileClearAll = () => {
    setModalPurchasesUrlParams({
      numberofDays: DEFAULT_PURCHASES_PARAMETERS.numberofDays,
      q: DEFAULT_PURCHASES_PARAMETERS.q,
      sort: DEFAULT_PURCHASES_PARAMETERS.sort,
      additionalFilters: DEFAULT_PURCHASES_PARAMETERS.additionalFilters,
    });
    onClearAll();
  };

  const onCloseModal = () => {
    hideDateRangeMobile();
  };

  const onShowVehicles = () => {
    setPurchasesUrlParams({
      ...modalPurchasesUrlParams,
      sort:
        prevQ === "" && modalPurchasesUrlParams.q !== ""
          ? SORT_OPTIONS.RegistrationNumberAscending
          : modalPurchasesUrlParams.sort,
    });
    hideDateRangeMobile();
  };

  const setModalSelectedSortOption = (sort) => {
    setModalPurchasesUrlParams({
      ...modalPurchasesUrlParams,
      sort: sort.target.value,
    });
  };

  const setModalVrmQuery = (q) => {
    setModalPurchasesUrlParams({
      ...modalPurchasesUrlParams,
      q,
    });
  };

  const setModalAdditionalFilters = (additionalFilters) => {
    setModalPurchasesUrlParams({
      ...modalPurchasesUrlParams,
      additionalFilters,
    });
  };

  const setModalSelectedFilter = (numberofDays) => {
    setModalPurchasesUrlParams({
      ...modalPurchasesUrlParams,
      numberofDays,
    });
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setShouldShowVrmQueryWarning(
        modalPurchasesUrlParams.q.length < 3 &&
          modalPurchasesUrlParams.q.length !== 0
      );
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [modalPurchasesUrlParams.q]);

  return (
    <Box
      width="100%"
      height="100%"
      pt={6}
      backgroundColor="primary-white"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      overflow="hidden"
    >
      <Header
        onCloseModal={onCloseModal}
        isScrolledToTop={isScrolledToTop}
        modalVrmQuery={modalPurchasesUrlParams.q}
        setModalVrmQuery={setModalVrmQuery}
        shouldShowVrmQueryWarning={shouldShowVrmQueryWarning}
        onShowVehicles={onShowVehicles}
      />
      <Content
        finalFilter={modalPurchasesUrlParams.numberofDays}
        setIsScrolledToTop={setIsScrolledToTop}
        setModalSelectedFilter={setModalSelectedFilter}
        filters={filters}
        modalSelectedSortOption={modalPurchasesUrlParams.sort}
        onSortHandler={setModalSelectedSortOption}
        sortOptions={sortOptions}
        appliedCheckboxes={appliedCheckboxes}
        setAppliedCheckboxesCheckBoxGroup={setAppliedCheckboxesCheckBoxGroup}
        setAppliedCheckboxesCheckBoxGroupRemoveChip={
          setAppliedCheckboxesCheckBoxGroupRemoveChip
        }
        modalSelectedFilter={modalPurchasesUrlParams.numberofDays}
        setTotalResults={setTotalResults}
        modalPurchasesUrlParams={modalPurchasesUrlParams}
        setModalAdditionalFilters={setModalAdditionalFilters}
        setAppliedCheckboxesSingleSelect={setAppliedCheckboxesSingleSelect}
        isToUseAuthZero={isToUseAuthZero}
      />
      <Footer
        onShowVehicles={onShowVehicles}
        shouldShowVrmQueryWarning={shouldShowVrmQueryWarning}
        onClearAll={onMobileClearAll}
        isClearAllDisabled={isMobileClearAllDisabled}
        totalResults={totalResults}
      />
    </Box>
  );
};

export default DateRangeMobileContainer;
